import React, { useState } from "react";
import { Button, Form, notification, Select, Upload, Space, Input, message, Image } from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { GrUpload } from "react-icons/gr";
import CategoryRequest from "./CategoryRequest";
import { useNavigate } from "react-router-dom";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const CreateCategories = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
    const [submited, setSubmit] = useState(false);
  const [form] = Form.useForm();

  const update=()=>{
    setSubmit(true);
  }

  
  const onFinish = (values) => {
    console.log(values)
    if(submited){
    setLoading(true);
    const allFormData = { ...values };
    console.log(allFormData)
    CategoryRequest.createCategory(allFormData)
      .then((res) => {
        if (res.status === 201) {
          notification.success({
            message: "Category added successfully",
          });
          navigate(-1);
        } else {
          notification.error({
            message: "Something went wrong",
          });
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        notification.error({
          message: "Failed to add category",
        });
        console.error("API Error:", e);
      });
    }
  };


  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleImageChange = ({ fileList: newFileList }) => setFileList(newFileList);

  const uploadButton = (
    <button style={{ border: 0, background: "none" }}>
      <GrUpload />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );
  

  const imageUpload = (file, name) => {
    setLoading(true);
    console.log(file, name, 'filename')
    const modifiedFile = new File([file], name, { type: file.type });
    let formData = new FormData();
    formData.append("file", modifiedFile);
    formData.append("fileName", name);
    CategoryRequest
      .uploadImage(formData)
      .then((res) => {
        setLoading(false);
        form.setFieldsValue({
          categoryImage: res?.data?.uploadDirectory,

        });
        console.log(res)
        if (res) {
          return true;
        } else {
          return false;
        }
      })
      .catch((e) => {
        setLoading(false);
        notification["error"]({
          message: "File upload Failed",
        })
      }
      );
  };

  // const props = {
  //   name: "file",
  //   multiple: false,
  //   accept : "image/*",
  //   beforeUpload: (file) => {
  //     const isImage = file.type.startsWith("image/");
  //     if(!isImage){
  //       notification.error({
  //         message : "Invalid file type",
  //         description : "Only image files are allowed (jpg, png, jpeg, webp)",
  //       });
  //       return Upload.LIST_IGNORE; 
  //     }
  //     imageUpload(file, file.name);
  //     return false;
  //   },
  //   onRemove() {
  //     setFileList([]);
  //   },
  // };

    const props = {
    name: "file",
    multiple: false,
    accept : "image/*",
    beforeUpload: (file) => {
      const isImage = file.type.startsWith("image/");
      if(!isImage){
        notification.error({
          message : "Invalid file type",
          description : "Only image files are allowed (jpg, png, jpeg, webp)",
        });
        return Upload.LIST_IGNORE; 
      }
      imageUpload(file, file.name);
      return false;
    },
    onRemove() {
      setFileList([]);
    },
  };



  return (
    <section>
      <div className="Create-Category"> 
        <div span={24}>
          <Form.Item className="submit-btn">
            <Space>
              <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
        </div>
        <h3>Create Category</h3>

        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          initialValues={null}
          className="subscription-form"
          colon={true}
        >
          <div className="subscription">
            <Form.Item
              label="Category Name"
              name="categoryTitle"
              className="subscription-plan"
              rules={[{ required: true, message: "Please enter the category name!" },
              {
                pattern: /^[A-Za-z\s]+$/,
                message: "Category name can only contain alphabetic characters!",
              },
              ]}
            >
              <Input size="large" placeholder="Enter Category Name" />
            </Form.Item>

            <Form.Item
              label="Category Status"
              name="status"
              className="subscription-plan"
              rules={[{ required: true, message: "Please select the category status" }]}
            >
              <Select
                placeholder="Select The Category Status"
                // style={{ marginTop: "0.5rem", width: "99%" }}
                options={[
                  { value: "1", label: "Active" },
                  { value: "0", label: "Inactive" },
                ]}
              />
            </Form.Item>


          </div>

          <div className="subscription">
            <Form.Item
              label="Category Gender"
              name="gender"
              className="subscription-plan"
              rules={[{ required: true, message: "Please select the category gender" }]}
            >
              <Select
                placeholder="Select The Category Gender"
                // style={{ marginTop: "0.5rem", width: "99%" }}
                options={[
                  { value: "0", label: "Male" },
                  { value: "1", label: "Female" },
                ]}
              />
            </Form.Item>
          </div>

          <div className="upload-Img">
            <Form.Item label="Upload Category Images" name="categoryImage" className="subscription-plan">
              <Upload
                {...props} maxCount={1}
               
                listType="picture-card"
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleImageChange}
              >
                {fileList.length >= 8 ? null : uploadButton}
              </Upload>
              {previewImage && (
                <Image
                  wrapperStyle={{
                    display: "none",
                  }}
                  preview={{
                    visible: previewOpen,
                    onVisibleChange: (visible) => setPreviewOpen(visible),
                  }}
                  src={previewImage}
                />
              )}
            </Form.Item>
          </div>

          <div className="bottom-button">
            <div style={{ padding: "10px" }}>
              <Button type="primary" htmlType="submit" loading={loading} onClick={update}>
                Save & Proceed
                <span>
                  <AiOutlineRight />
                </span>
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </section>
  );
};

export default CreateCategories;
